'use client';

import React, { useEffect } from 'react';
import Callout from "./Callout";
import { Box, Loader, Container, SimpleGrid, Text, Title } from "@mantine/core";
import { MarkdownContent } from '@/app/page';

interface HomeCalloutSectionProps {
  markdownContent?: MarkdownContent;
}

/**
 * Usage Example
 */
const HomeCalloutSection = ({ markdownContent }: HomeCalloutSectionProps) => {
    const content = markdownContent?.frontmatter;
    // const { content, isLoading, error } = useHomeCallout();

    useEffect(() => {
        // console.log('Home Callout Section Markdown Content:', markdownContent);
    }, [markdownContent]);

    if (!content) return null;


    return (
        <Callout
            title={content.content.title}
            background={content.styles.background}
            padding={content.styles.padding}
            containerSize={content.styles.containerSize}
            gap={content.styles.gap}
            direction={content.styles.direction}
            titleStyles={content.styles.titleStyles}
            textStyles={content.styles.textStyles}
        >
            {content.content.description}
        </Callout>
    );
};

export default HomeCalloutSection;